import { makeRequest } from '../../../lib/api';
import {
  PositionGroupsCreateRequest,
  PositionGroupsRequest,
  PositionGroupsUpdateRequest,
} from '../api/positionGroups';

const POSITION_GROUP_PATH = '/v1/customer_api_service_catalog';

const positionGroupsController = {
  getPositionGroups: (request: PositionGroupsRequest): Promise<any> => {
    // const showDeletedString = request.showDeleted ? '?showDeleted=true' : '';
    return makeRequest('get', `${ POSITION_GROUP_PATH }?showDeleted=${ request.showDeleted }`);
  },

  createPositionGroup: (request: PositionGroupsCreateRequest): Promise<any> => {
    return makeRequest('post', POSITION_GROUP_PATH, request);
  },

  updatePositionGroup: (request: PositionGroupsUpdateRequest): Promise<any> => {
    return makeRequest('put', `${ POSITION_GROUP_PATH }/${ request.id }`, request);
  },

  deletePositionGroup: (id: number): Promise<any> => {
    return makeRequest('delete', `${ POSITION_GROUP_PATH }/${ id }`);
  },

  restorePositionGroup: (id: number): Promise<any> => {
    return makeRequest('put', `${ POSITION_GROUP_PATH }/${ id }/restore`);
  },
};

export { positionGroupsController };
